import { render, staticRenderFns } from "./SaveButtonDropdown.vue?vue&type=template&id=3566d5fd&"
import script from "./SaveButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./SaveButtonDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports